
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from '@zola/zola-ui';
import { getOtherRegistries } from '../../../../actions/RegistryBulkImportActions';
import BlankState from './BlankState';
import OtherRegistries from './OtherRegistries';

import './OtherRegistriesContainer.less';

class OtherRegistriesContainer extends Component {

  componentDidMount() {
    const { onFetchOtherRegistries } = this.props;
    document.title = 'Your Other Registries';
    onFetchOtherRegistries();
  }

  renderOtherRegistries() {
    const { otherRegistriesDetails } = this.props;

    return (
      <div className="other-registries__container">
        <h3 className="other-registries__container__header settings-page-header">Your Other Registries</h3>
        {otherRegistriesDetails
          ? (
            <div>
              {otherRegistriesDetails.length <= 0
                && <BlankState />
              }
              {otherRegistriesDetails.length > 0
                && <OtherRegistries otherRegistriesDetails={otherRegistriesDetails} />
              }
            </div>
          )
          : null
        }
        <div className="other-registries__container__help-cta">
          <span>Questions? </span><Link size="lg" className="other-registries__container__help-link" inline href="https://help.zola.com/hc/en-us" target="_blank">We&apos;re here to help.</Link>
        </div>
      </div>
    )
  }

  render() {
    const { hasRegistryAccount } = this.props;
    let component = '';
    let redirectTo = null;

    if (hasRegistryAccount) {
      component = this.renderOtherRegistries();
    } else {
      redirectTo = '/account/settings/info';
    }

    if (redirectTo) {
      window.location.href = redirectTo;
    }

    return (
      component
    );
  }
}

OtherRegistriesContainer.propTypes = {
  otherRegistriesDetails: PropTypes.arrayOf(PropTypes.shape({})),
  hasRegistryAccount: PropTypes.bool,

};

const mapStateToProps = state => ({
  otherRegistriesDetails: state.registryBulkImport.otherRegistries,
  hasRegistryAccount: state.user.userContext.has_registry,
});

const mapDispatchToProps = dispatch => ({
  onFetchOtherRegistries: () => dispatch(getOtherRegistries())
});


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OtherRegistriesContainer);



// WEBPACK FOOTER //
// ./src/components/settings/registry/OtherRegistries/OtherRegistriesContainer.jsx